import { render, staticRenderFns } from "./RenderHistorySuper.vue?vue&type=template&id=d31181ae"
import script from "./RenderHistorySuper.vue?vue&type=script&lang=js"
export * from "./RenderHistorySuper.vue?vue&type=script&lang=js"
import style0 from "./RenderHistorySuper.vue?vue&type=style&index=0&id=d31181ae&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports